import { SimpleGrid } from "@chakra-ui/react";
import React from "react";
import MultiFileUpload from "../../../components/Common/CustomUpload/MultiFileUpload";
import { IData } from "./types";
import { IData as IPackageData } from "../package/types";
import { IData as IRetailerProductData } from "../retailer-product/types";
import { useTranslation } from "react-i18next";

interface FileUploadBoxProps {
  handleChangeFeaturedImage: (val: string) => void;
  handleChangeUploadField: (name: string, val: any) => void;
  handleDeleteFile: (name: string, index: number) => void;
  form: IData | IPackageData | IRetailerProductData;
}

const FileUploadBox: React.FC<FileUploadBoxProps> = ({
  handleChangeFeaturedImage,
  form,
  handleChangeUploadField,
  handleDeleteFile,
}) => {
  const { t } = useTranslation();

  return (
    <SimpleGrid columns={[1, 1, 2, 3, 4]} spacingX={5}>
      <MultiFileUpload
        data={form?.featuredImage}
        handleUploadImage={(val: any) => {
          handleChangeFeaturedImage(val);
        }}
        title={`${t("common.form.featuredImage")}`}
        hideDelete
        isSingle
      />
      <MultiFileUpload
        data={form?.images}
        handleDeleteFile={(index) => {
          handleDeleteFile("images", index);
        }}
        handleUploadImage={(val: any) => {
          handleChangeUploadField("images", val);
        }}
        title={`${t("common.form.uploadFile")}`}
        isRequiredFalse
      />
      <MultiFileUpload
        data={form?.allergicImages}
        handleDeleteFile={(index) => {
          handleDeleteFile("allergicImages", index);
        }}
        handleUploadImage={(val: any) => {
          handleChangeUploadField("allergicImages", val);
        }}
        title={`${t("common.form.allergicFile")}`}
      />
      <MultiFileUpload
        data={form?.stickers}
        handleDeleteFile={(index) => {
          handleDeleteFile("stickers", index);
        }}
        handleUploadImage={(val: any) => {
          handleChangeUploadField("stickers", val);
        }}
        title={`${t("common.form.stickersFile")}`}
      />
    </SimpleGrid>
  );
};

export default FileUploadBox;
